import { api } from '@/api/http';
import { socket } from '@/api/socket';
import { SOCKET_EVENTS } from '@/api/socket-events';
import SendMessageModal from '@/pages/client/send-message-modal';
import SelectTgStatus from '@/components/select-tg-status';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import type { IClient } from '@/entities/client.entity';
import { AxeIcon } from 'lucide-react';
import { toast } from 'sonner';

interface ClientActionsProps {
	client: IClient;
}

export default function ClientActions({ client }: ClientActionsProps) {
	function handleChangeTakeStatus(val: string) {
		socket.emit(SOCKET_EVENTS.changeTakeStatus, { clientId: client.id, status: Number(val) });
	}

	async function handleMainZipDownload() {
		if (!client.fileName) return toast.error('У клиента нет зипа');
		await api.get(`/zip/${client.id}`).then(() => {
			toast.success('ZIP отправлен ⤴️', { position: 'top-center', duration: 2500 });
		});
	}

	async function handleContactsZipDownload() {
		if (!client.contactsFileName) return toast.error('У клиента нет зипа контактов');
		await api.get(`/zip/${client.id}/contacts`).then(() => {
			toast.success('ZIP контактов отправлен ⤴️', { position: 'top-center', duration: 2500 });
		});
	}

	return (
		<div className='grid gap-2'>
			<div className='flex gap-1.5 items-center'>
				<SelectTgStatus client={client} />
				<div className='flex-1 min-w-0'>
					<SendMessageModal client={client} compact />
				</div>
				<Select value={String(client.takeStatus)} onValueChange={handleChangeTakeStatus}>
					<SelectTrigger className='w-[88px] h-9 shrink-0'>
						<SelectValue />
					</SelectTrigger>
					<SelectContent>
						<SelectItem value='0'>
							<AxeIcon size={18} className='text-gray-500' /> Не вбит
						</SelectItem>
						<SelectItem value='1'>
							<AxeIcon size={18} className='text-chart-4' /> На вбиве
						</SelectItem>
						<SelectItem value='2'>
							<AxeIcon size={18} className='text-chart-2' /> Успешно
						</SelectItem>
						<SelectItem value='3'>
							<AxeIcon size={18} className='text-[#c09b83]' /> Говно
						</SelectItem>
					</SelectContent>
				</Select>
			</div>

			<div className='flex flex-wrap gap-1.5 items-center min-h-7'>
				{client.newLaunchStatus === 0 ? (
					<Button
						variant='outline'
						size='sm'
						className='h-8 text-xs'
						onClick={() => socket.emit(SOCKET_EVENTS.createActionLaunch, { clientId: client.id })}
					>
						Запросить Launch
					</Button>
				) : client.newLaunchStatus === 1 ? (
					<span className='text-sm text-[#ff9d00]'>Launch команда создана</span>
				) : client.newLaunchStatus === 2 ? (
					<div className='flex gap-1.5 items-center'>
						<span className='text-sm text-green-500'>Launch получена</span>
						<Button
							variant='outline'
							size='sm'
							className='h-7 text-xs'
							onClick={() => socket.emit(SOCKET_EVENTS.createActionLaunch, { clientId: client.id })}
						>
							Перезапросить
						</Button>
					</div>
				) : (
					<span className='text-sm opacity-60'>Неизвестный статус</span>
				)}
				<Button variant='outline' size='sm' className='h-8 text-xs' onClick={handleMainZipDownload}>
					Main ZIP
				</Button>
				<Button variant='outline' size='sm' className='h-8 text-xs' onClick={handleContactsZipDownload}>
					Contacts ZIP
				</Button>
				<Button
					variant='outline'
					size='sm'
					className='h-8 text-xs'
					onClick={() => socket.emit(SOCKET_EVENTS.createActionPhotoScanStart, { clientId: client.id })}
				>
					Скан фото
				</Button>
				<Button
					variant='outline'
					size='sm'
					className='h-8 text-xs'
					onClick={() => socket.emit(SOCKET_EVENTS.createActionPhotoScanStop, { clientId: client.id })}
				>
					Стоп фото
				</Button>
			</div>
		</div>
	);
}
